import { render, staticRenderFns } from "./UserNotifications.vue?vue&type=template&id=bec73934&scoped=true&"
import script from "./UserNotifications.vue?vue&type=script&lang=ts&"
export * from "./UserNotifications.vue?vue&type=script&lang=ts&"
import style0 from "./UserNotifications.vue?vue&type=style&index=0&id=bec73934&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bec73934",
  null
  
)

export default component.exports